import { LMS_API_KEY, TENANT_ID } from "../../../config-global";
import { ServiceResponse } from "../../types";
import LmsBuildClient from "../../../../build/buildClient";
import base from "./base";
import { IGlossary } from "./base/types";
import { GET_BUILD_GLOSSARY, GET_BUILD_GLOSSARIES } from "./graphql";
import { GetBuildGlossaryInput, GetBuildGlossariesInput } from "./types";

const getBuildGlossaries = async (
    lastUpdated: string
): Promise<ServiceResponse<IGlossary[] | undefined>> => {
    let data: any | undefined;
    try {
        const input: GetBuildGlossariesInput = {
            tenantId: TENANT_ID,
            so: lastUpdated,
            limit: 1000
        };
        data = (
            await LmsBuildClient.request({
                method: "post",
                headers: {
                    "x-api-key": LMS_API_KEY,
                },
                data: {
                    query: GET_BUILD_GLOSSARIES,
                    variables: {
                        input,
                    },
                },
            })
        )?.data;

        return {
            ...data.data.getBuildGlossaries,
            success: !!data.data.getBuildGlossaries.data,
        };
    } catch (err) {
        console.error("getBuildGlossaries", err);
        if (data?.errors) {
            console.error("getBuildGlossaries", data?.errors);
        }
        return {
            success: false,
        };
    }
};

const getBuildGlossary = async (
    id: string
): Promise<ServiceResponse<IGlossary | undefined>> => {
    let data: any | undefined;

    const input: GetBuildGlossaryInput = {
        tenantId: TENANT_ID,
        id,
    };

    try {


        data = (
            await LmsBuildClient.request({
                method: "post",
                headers: {
                    "x-api-key": LMS_API_KEY,
                },
                data: {
                    query: GET_BUILD_GLOSSARY,
                    variables: {
                        input,
                    },
                },
            })
        )?.data;

        return {
            data: data.data.getBuildGlossary,
            success: !!data.data.getBuildGlossary,
        };
    } catch (err) {
        console.error("getBuildGlossary", err, input);
        if (data?.errors) {
            console.error("getBuildGlossary", data?.errors);
        }
        return {
            success: false,
        };
    }
};

const GlossaryService = { ...base, getBuildGlossaries, getBuildGlossary };

export default {
    ...GlossaryService,
};
